import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "research" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ReasoningHead = _resolveComponent("ReasoningHead")
  const _component_SmoothResize = _resolveComponent("SmoothResize")
  const _component_ReasoningList = _resolveComponent("ReasoningList")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SmoothResize, {
      active: `item-${$data.items.length - 1}`
    }, _createSlots({ _: 2 /* DYNAMIC */ }, [
      _renderList($data.items, (item, idx) => {
        return {
          name: `item-${idx}`,
          fn: _withCtx(() => [
            _createVNode(_component_ReasoningHead, {
              title: $props.completed ? $options.title : item.title,
              open: $data.open,
              completed: $props.completed,
              onClick: _cache[0] || (_cache[0] = $event => ($data.open = !$data.open))
            }, null, 8 /* PROPS */, ["title", "open", "completed"])
          ])
        }
      })
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["active"]),
    _createVNode(_component_ReasoningList, {
      open: $data.open,
      items: $data.items,
      completed: $props.completed
    }, null, 8 /* PROPS */, ["open", "items", "completed"])
  ]))
}